import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Play.svg",
  "use": "Play.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Play.svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 47.1828L45.2711 32.7421L20 18.3015V47.1828ZM16 16.004V49.4803C16 51.5279 18.212 52.8115 19.9897 51.7956L49.2815 35.0575C51.073 34.0337 51.073 31.4505 49.2815 30.4268L19.9897 13.6886C18.212 12.6728 16 13.9564 16 16.004Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol